import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
var VeltActivityLogListItemContentUserWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-list-item-content-user-wireframe", __assign({}, transformedProps), children));
};
export default VeltActivityLogListItemContentUserWireframe;
